<template>
  <v-container id="homecard" fill-height>
    <v-layout
      justify-center
      align-center 
    >
      <v-flex text-xs-center fill-height>
        <v-card max-height="100%">
          <v-list height="100%" color="#303030">
            <v-list-group
              prepend-icon="mdi-calendar"
              no-action
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>PRESCRIPCIONES 20/06/2020</v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item
                v-for="subItem in prescripciones20200620"
                :key="subItem.afiliado"
              >
                <v-list-item-content>
                  <v-list-item-title v-text="subItem.afiliado"></v-list-item-title>
                  <v-list-item-subtitle v-text="subItem.plan"></v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                  <v-btn icon>
                    <v-icon color="grey lighten-1">mdi-information</v-icon>
                  </v-btn>
                </v-list-item-action>

              </v-list-item>
            </v-list-group>

            <v-list-group
              prepend-icon="mdi-calendar"
              no-action
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>PRESCRIPCIONES 19/06/2020</v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item
                v-for="subItem in prescripciones20200619"
                :key="subItem.afiliado"
              >
                <v-list-item-content>
                  <v-list-item-title v-text="subItem.afiliado"></v-list-item-title>
                  <v-list-item-subtitle v-text="subItem.plan"></v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                  <v-btn icon>
                    <v-icon color="grey lighten-1">mdi-information</v-icon>
                  </v-btn>
                </v-list-item-action>

              </v-list-item>
            </v-list-group>

            <v-list-group
              prepend-icon="mdi-calendar"
              no-action
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>PRESCRIPCIONES 18/06/2020</v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item
                v-for="subItem in prescripciones20200618"
                :key="subItem.afiliado"
              >
                <v-list-item-content>
                  <v-list-item-title v-text="subItem.afiliado"></v-list-item-title>
                  <v-list-item-subtitle v-text="subItem.plan"></v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                  <v-btn icon>
                    <v-icon color="grey lighten-1">mdi-information</v-icon>
                  </v-btn>
                </v-list-item-action>

              </v-list-item>
            </v-list-group>
          </v-list>
        </v-card>
      </v-flex>
    </v-layout>


    <v-speed-dial
      v-model="fab"
      :bottom="true" :right="true" :top="false" :left="false"
      direction="top"
      transition="slide-x-reverse-transition"
    >
      <template v-slot:activator>
        <v-btn
          v-model="fab"
          color="warning"
          fab
        >
          <v-icon v-if="fab">mdi-close</v-icon>
          <v-icon v-else>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            fab
            small
            color="warning"
            v-bind="attrs"
            v-on="on"
            @click.prevent="$router.push('/prescribir')"
          >
            <v-icon>mdi-grease-pencil</v-icon>
          </v-btn>
        </template>
        <span>Prescribir</span>
      </v-tooltip>
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            fab
            small
            color="warning"
            v-bind="attrs"
            v-on="on"
            @click.prevent="$router.push('/home')"
          >
            <v-icon>mdi-home</v-icon>
          </v-btn>
        </template>
        <span>Inicio</span>
      </v-tooltip>
    </v-speed-dial>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: 'Prescripciones',

  data: () => ({
    fab: false,
    prescripciones20200618: [
      { icon: 'mdi-calendar-check', iconClass: 'secondary', afiliado: '(29447388) Germán Alberto Arias', plan: 'Plan: Diabetes - Duración: 4 meses' },
      { icon: 'mdi-calendar', iconClass: 'primary black--text', afiliado: '(5605794) Carlos Gutierrez', plan: 'Plan: Oncologico - Duración: 6 meses' },
      { icon: 'mdi-calendar-remove', iconClass: 'warning', afiliado: '(28132603) Nahuel Alejandro Ramos', plan: 'Plan: Crónico - Duración: 4 meses' },
    ],
    prescripciones20200619: [
      { icon: 'mdi-calendar-remove', iconClass: 'warning', afiliado: '(28132601) Nahuel Alejandro Ramos', plan: 'Plan: Crónico - Duración: 4 meses' },
      { icon: 'mdi-calendar', iconClass: 'primary black--text', afiliado: '(5605792) Carlos Gutierrez', plan: 'Plan: Oncologico - Duración: 6 meses' },
      { icon: 'mdi-calendar-check', iconClass: 'secondary', afiliado: '(29447386) Germán Alberto Arias', plan: 'Plan: Diabetes - Duración: 4 meses' },
    ],
    prescripciones20200620: [
      { icon: 'mdi-calendar', iconClass: 'primary black--text', afiliado: '(5605793) Carlos Gutierrez', plan: 'Plan: Oncologico - Duración: 6 meses' },
      { icon: 'mdi-calendar-remove', iconClass: 'warning', afiliado: '(28132602) Nahuel Alejandro Ramos', plan: 'Plan: Crónico - Duración: 4 meses' },
      { icon: 'mdi-calendar-check', iconClass: 'secondary', afiliado: '(29447387) Germán Alberto Arias', plan: 'Plan: Diabetes - Duración: 4 meses' },
    ],
  }),

  computed: {
    ...mapGetters({
      user: "user"
    })
  },
}
</script>

<style>
#homecard .v-speed-dial {
  position: absolute;
}

#homecard .v-btn--floating {
  position: relative;
}
</style>